import { initializeAccordion } from "./helpers/initialize-accordion";

const Accordion = () => {
  initializeAccordion(".accordion__list", ".accordion__item", ".accordion__item-title", ".accordion__content-wrapper");
};

export default Accordion;